/*
* Pipeline Theme - custom.js
*
* Campos de facturación B2B para el producto mayorista.
* Solo se activan en /products/pedido-mayorista-inciensos y solo sobre el
* formulario cuyo input name="id" coincide con VARIANT_ID.
*/

(function () {
  'use strict';

  var HANDLE = 'pedido-mayorista-inciensos';
  var VARIANT_ID = '53626808926474';

  var FIELDS = [
    { name: 'Razón social', required: true },
    { name: 'NIF / CIF', required: true },
    { name: 'Domicilio fiscal', required: true },
    { name: 'Email de facturación', required: true, type: 'email' },
    { name: 'VAT intracomunitario', required: false, help: 'Solo si la empresa está fuera de España y dentro de la UE.' },
    { name: 'Persona de contacto', required: false },
    { name: 'Referencia del comprador', required: false }
  ];

  function slug(s) {
    return s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function injectStyles() {
    if (document.getElementById('wholesale-fields-css')) return;
    var css = document.createElement('style');
    css.id = 'wholesale-fields-css';
    css.textContent = [
      '.wholesale-fields{margin:1.25rem 0;padding:1.1rem 1.2rem;border:1px solid rgba(128,128,128,.35);border-radius:8px;}',
      '.wholesale-fields__title{margin:0 0 .3rem;font-weight:600;font-size:1rem;}',
      '.wholesale-fields__sub{margin:0 0 1rem;font-size:.82rem;opacity:.7;line-height:1.4;}',
      '.wholesale-fields__row{margin-bottom:.85rem;}',
      '.wholesale-fields__row label{display:block;font-size:.85rem;margin-bottom:.3rem;}',
      '.wholesale-fields__row input{width:100%;padding:.65rem .7rem;border:1px solid rgba(128,128,128,.45);border-radius:4px;font:inherit;font-size:.95rem;background:transparent;color:inherit;box-sizing:border-box;}',
      '.wholesale-fields__row input:focus{outline:2px solid currentColor;outline-offset:1px;}',
      '.wholesale-fields__row small{display:block;margin-top:.3rem;font-size:.75rem;opacity:.6;line-height:1.35;}',
      '.wholesale-fields__row.is-invalid input{border-color:#c0392b;}',
      'shopify-forms-embed{display:none !important;}'
    ].join('');
    document.head.appendChild(css);
  }

  function tidyLayout() {
    // Producto sin imagen: ocultamos la columna de media vacía y centramos el contenido.
    var placeholder = document.querySelector('.product__image__placeholder');
    if (placeholder) {
      var media = placeholder.closest('.product__media__wrapper');
      if (media && media.getAttribute('data-wholesale-hidden') !== '1') {
        media.setAttribute('data-wholesale-hidden', '1');
        media.style.display = 'none';
        var content = document.querySelector('.product__main__content');
        if (content) {
          content.classList.remove('medium-up--one-half');
          content.classList.add('medium-up--one-whole');
          content.style.maxWidth = '620px';
          content.style.marginLeft = 'auto';
          content.style.marginRight = 'auto';
        }
      }
    }
    // Una página B2B no debe mostrar el popup de captación de la tienda.
    var embeds = document.querySelectorAll('shopify-forms-embed');
    for (var i = 0; i < embeds.length; i++) {
      embeds[i].style.setProperty('display', 'none', 'important');
    }
  }

  function buildFields() {
    var wrap = document.createElement('div');
    wrap.className = 'wholesale-fields';

    var title = document.createElement('p');
    title.className = 'wholesale-fields__title';
    title.textContent = 'Datos de facturación';
    wrap.appendChild(title);

    var sub = document.createElement('p');
    sub.className = 'wholesale-fields__sub';
    sub.textContent = 'Necesarios para emitir la factura. Los campos con * son obligatorios.';
    wrap.appendChild(sub);

    FIELDS.forEach(function (f) {
      var id = 'wh-' + slug(f.name);
      var row = document.createElement('div');
      row.className = 'wholesale-fields__row';

      var label = document.createElement('label');
      label.setAttribute('for', id);
      label.textContent = f.required ? f.name + ' *' : f.name;
      row.appendChild(label);

      var input = document.createElement('input');
      input.type = f.type || 'text';
      input.id = id;
      input.name = 'properties[' + f.name + ']';
      input.setAttribute('autocomplete', 'off');
      if (f.required) input.required = true;
      row.appendChild(input);

      if (f.help) {
        var help = document.createElement('small');
        help.textContent = f.help;
        row.appendChild(help);
      }

      wrap.appendChild(row);
    });

    return wrap;
  }

  function validate(wrap) {
    var rows = wrap.querySelectorAll('.wholesale-fields__row');
    for (var i = 0; i < rows.length; i++) {
      rows[i].classList.remove('is-invalid');
    }
    var inputs = wrap.querySelectorAll('input');
    for (var j = 0; j < inputs.length; j++) {
      var el = inputs[j];
      var empty = el.required && !el.value.trim();
      var bad = el.value.trim() && typeof el.checkValidity === 'function' && !el.checkValidity();
      if (empty || bad) {
        el.parentNode.classList.add('is-invalid');
        el.focus();
        if (typeof el.reportValidity === 'function') el.reportValidity();
        return false;
      }
    }
    return true;
  }

  function isTargetForm(form) {
    var idInput = form.querySelector('[name="id"]');
    return !!idInput && String(idInput.value) === VARIANT_ID;
  }

  function enhance(form) {
    if (form.getAttribute('data-wholesale-ready') === '1') return;
    form.setAttribute('data-wholesale-ready', '1');

    injectStyles();
    var wrap = buildFields();

    var submitBtn = form.querySelector('[name="add"]') || form.querySelector('[type="submit"]');
    if (submitBtn && submitBtn.parentNode) {
      submitBtn.parentNode.insertBefore(wrap, submitBtn);
    } else {
      form.appendChild(wrap);
    }

    // El botón de pago rápido salta el formulario y se saltaría la validación.
    var dynamic = form.querySelector('.shopify-payment-button');
    if (dynamic) dynamic.style.display = 'none';

    // Fase de captura: se ejecuta antes del handler AJAX del tema.
    form.addEventListener('submit', function (e) {
      if (!validate(wrap)) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    }, true);

    if (submitBtn) {
      submitBtn.addEventListener('click', function (e) {
        if (!validate(wrap)) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      }, true);
    }
  }

  function scan() {
    if (window.location.pathname.indexOf('/products/' + HANDLE) === -1) return;
    injectStyles();
    tidyLayout();
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      if (isTargetForm(forms[i])) enhance(forms[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  window.addEventListener('load', scan);
  document.addEventListener('theme:variant:change', scan);
})();
